import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// IMPORTANT: Replace these values with your actual Firebase project configuration
// You can find these values in your Firebase project settings
const firebaseConfig = {
    apiKey: "AIzaSyBaQc7-glXXDHqcF9zOdkGX2fY9zAR11dk",
    authDomain: "dancecup-ea493.firebaseapp.com",
    databaseURL: "https://dancecup-ea493-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "dancecup-ea493",
    storageBucket: "dancecup-ea493.firebasestorage.app",
    messagingSenderId: "429439102056",
    appId: "1:429439102056:web:7e5008192043acaf3d5fdd",
    measurementId: "G-74E7KN1VQF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

// Configure authentication providers
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

export { auth, db, googleProvider }; 